import * as React from 'react';

function Empty(props) {
	return (
		<svg
			width="60"
			height="60"
			viewBox="0 0 60 60"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z"
				fill="#D7E2F8"
			/>
			<path
				opacity="0.15"
				d="M28.5435 31.48C28.5435 31.1333 28.6568 30.8467 28.8835 30.62C29.1101 30.38 29.3968 30.26 29.7435 30.26C30.2901 30.26 30.7835 30.18 31.2235 30.02C31.6635 29.8467 32.0101 29.5733 32.2635 29.2C32.5301 28.8267 32.6635 28.3333 32.6635 27.72C32.6635 27.2667 32.5501 26.8667 32.3235 26.52C32.1101 26.1733 31.8101 25.9 31.4235 25.7C31.0501 25.5 30.6235 25.4 30.1435 25.4C29.7701 25.4 29.4168 25.4667 29.0835 25.6C28.7635 25.7333 28.4701 25.9133 28.2035 26.14C27.9901 26.3267 27.7301 26.4667 27.4235 26.56C27.1301 26.64 26.8301 26.5667 26.5235 26.34C26.2035 26.1 26.0301 25.8133 26.0035 25.48C25.9768 25.1467 26.1035 24.84 26.3835 24.56C26.8635 24.0667 27.4235 23.6867 28.0635 23.42C28.7168 23.14 29.4101 23 30.1435 23C31.0635 23 31.8901 23.2133 32.6235 23.64C33.3701 24.0533 33.9635 24.6133 34.4035 25.32C34.8435 26.0267 35.0635 26.8267 35.0635 27.72C35.0635 28.3867 34.9635 28.98 34.7635 29.5C34.5635 30.0067 34.2768 30.4467 33.9035 30.82C33.5435 31.18 33.1168 31.4733 32.6235 31.7C32.1435 31.9133 31.6168 32.0667 31.0435 32.16C31.0168 32.1733 30.9901 32.1867 30.9635 32.2C30.9501 32.2133 30.9435 32.2333 30.9435 32.26V33C30.9435 33.3467 30.8301 33.64 30.6035 33.88C30.3768 34.1067 30.0901 34.22 29.7435 34.22C29.3968 34.22 29.1101 34.1067 28.8835 33.88C28.6568 33.64 28.5435 33.3467 28.5435 33V31.48ZM29.6435 37.8C29.2568 37.8 28.9568 37.7 28.7435 37.5C28.5435 37.2867 28.4435 36.9867 28.4435 36.6V36.26C28.4435 35.8733 28.5435 35.58 28.7435 35.38C28.9568 35.1667 29.2568 35.06 29.6435 35.06H29.9035C30.2901 35.06 30.5835 35.1667 30.7835 35.38C30.9968 35.58 31.1035 35.8733 31.1035 36.26V36.6C31.1035 36.9867 30.9968 37.2867 30.7835 37.5C30.5835 37.7 30.2901 37.8 29.9035 37.8H29.6435Z"
				fill="#1F1F43"
			/>
		</svg>
	);
}

export default Empty;
